import { Input } from 'antd';
import { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getErrorMessage } from '../../../queries/errorHandling.ts';
import { IVehicle } from '../../../schema/Vehicle.ts';
import { useGroupedVehiclesByTerritory } from '../../../services/Vehicle.ts';
import { CustomSpinner } from '../../ui/Spinner.tsx';
import { VehicleGroup } from './VehicleGroup.tsx';

export function Fleet() {
  const { t } = useTranslation();
  const params = useParams() as { territorySlug: string };
  const [search, setSearch] = useState('');
  const { grouped, isLoading, error } = useGroupedVehiclesByTerritory(params.territorySlug);

  const filterVehicles = (vehicles: IVehicle[]) => {
    if (search.length < 2) return vehicles;
    const lower = search.toLowerCase();
    return vehicles.filter(
      v =>
        v.display_identifier.toLowerCase().includes(lower) ||
        v.shuttle_provider_identifier.toLowerCase().includes(lower) ||
        v.provider.toLowerCase().includes(lower) ||
        v.id.toString().includes(lower),
    );
  };

  return (
    <>
      {isLoading ? (
        <CustomSpinner class={'text-center'} />
      ) : error ? (
        <p className={'text-center mt-5'}>{getErrorMessage(error, 'fleet.error')}</p>
      ) : (
        <>
          <div className="px-4 mb-2 mt-2">
            <Input
              placeholder={t('fleet.search-placeholder')}
              allowClear
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <Accordion className="mb-5 ms-4 me-4">
            <div className="accordion accordion-flush">
              <VehicleGroup
                vehicles={filterVehicles(grouped.InOperation)}
                groupName={'IN_OPERATION'}
                totalCount={grouped.total}
              />
              <VehicleGroup
                vehicles={filterVehicles(grouped.PlannedOperation)}
                groupName={'PLANNED_OPERATION'}
                totalCount={grouped.total}
                extraStyle={'mt-3'}
              />
              <VehicleGroup
                vehicles={filterVehicles(grouped.Inactive)}
                groupName={'NO_OPERATION'}
                totalCount={grouped.total}
                extraStyle={'mt-3'}
              />
            </div>
          </Accordion>
        </>
      )}
    </>
  );
}
